<template>
  <div>
    <vue-dropzone
      ref="myVueDropzone"
      id="dropzone"
      :options="dropzoneOptions"
      v-on:vdropzone-success="setOrderDocsUrl"
      v-on:vdropzone-removed-file="removeOrderDocsUrl"
      class="mb-0">
    </vue-dropzone>
  </div>
</template>

<script>
import VueDropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  name: 'CustomVueDropzone',
  components: {
    VueDropzone
  },
  props: {
    dropzoneMessage: {
      type: String,
      default: 'Documents'
    },
    maxFile: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      dropzoneOptions: {
        url: 'https://upload.keepneye.com/upload',
        thumbnailWidth: 200,
        maxFilesize: 10.5,
        addRemoveLinks: true,
        maxFiles: this.maxFile,
        dictDefaultMessage: this.dropzoneMessage + `. (10.5 Mb MAX)`,
        renameFile: function (file) {
          let newName = Math.random().toString(36).substr(2, 9) + '_' + file.name
          return newName
        }
      }
    }
  },

  methods: {
    // Custom Input file: VueDropZone file upload successful
    // Set URL for order doc
    setOrderDocsUrl (file, response) {
      const dropzoneFile = response.data.URL
      this.$refs.myVueDropzone.disable()

      this.emitNewDropzoneFile(dropzoneFile)
    },

    // Custom Input file, functions: VueDropZone file removed
    // Reset order docs, remove file from dropzone. re-enable dropzone
    removeOrderDocsUrl (file, error, xhr) {
      const dropzoneFile = ''
      this.$refs.myVueDropzone.removeAllFiles()
      this.$refs.myVueDropzone.enable()

      this.emitNewDropzoneFile(dropzoneFile)
    },

    /** @emits CreateTransporterAccount.vue */
    emitNewDropzoneFile (file) {
      this.$emit('dropzoneFile', file)
    }
  }
}
</script>

<style scoped>
</style>
